(() => {
  const requests = new Map();
  const readBadge = markup => {
    const parsed = new DOMParser().parseFromString(markup, 'text/html');
    const badge = parsed.querySelector('.jdgm-prev-badge');
    if (!badge) return null;
    const count = Number(badge.getAttribute('data-number-of-reviews'));
    const rating = Number(badge.getAttribute('data-average-rating'));
    if (!Number.isInteger(count) || count <= 0 || !Number.isFinite(rating) || rating <= 0 || rating > 5) return null;
    return {count, rating};
  };
  const render = (host, info, href, label) => {
    host.replaceChildren();
    host.classList.remove('jdgm-widget', 'jdgm-preview-badge');
    host.dataset.damRatingReady = 'true';
    if (!info) return;
    const link = document.createElement('a');
    link.className = 'dam-v10-rating-link';
    link.href = href;
    link.setAttribute('aria-label', (label || '__RATING__ / 5 · __COUNT__').replaceAll('__RATING__', String(info.rating)).replaceAll('__COUNT__', String(info.count)));
    const stars = document.createElement('span');
    stars.className = 'dam-v10-stars'; stars.style.setProperty('--rating', String(info.rating)); stars.setAttribute('aria-hidden','true');
    const text = document.createElement('span');
    text.textContent = `(${info.count})`;
    link.append(stars,text); host.append(link);
  };
  // Attribute data survives Section Rendering; DOM children are intentionally disposable.
  // Morph may remove children without changing attributes, so observe that exact mutation too.
  if (!customElements.get('dam-v10-rating')) customElements.define('dam-v10-rating', class extends HTMLElement {
    static observedAttributes = ['data-dam-rating-source', 'data-dam-rating-url', 'data-dam-rating-label'];
    observer = new MutationObserver(() => this.scheduleRender());
    pending = false;
    connectedCallback() { this.scheduleRender(); }
    disconnectedCallback() { this.observer.disconnect(); }
    attributeChangedCallback() { this.scheduleRender(); }
    scheduleRender() {
      if (this.pending) return;
      this.pending = true;
      queueMicrotask(() => {
        this.pending = false;
        if (!this.isConnected) return;
        this.observer.disconnect();
        render(this, readBadge(this.dataset.damRatingSource || ''), this.dataset.damRatingUrl, this.dataset.damRatingLabel);
        this.observer.observe(this, {childList:true});
      });
    }
  });
  const activeLoads = new WeakMap();
  window.damV10Rating = {
    readBadge,
    async load(handle, host) {
      const token = {};
      activeLoads.set(host, token);
      const root = (window.Shopify?.routes?.root || '/').replace(/\/+$/, '') + '/';
      const url = new URL(`${root}products/${encodeURIComponent(handle)}`, location.origin);
      url.searchParams.set('section_id', 'dam-v10-product-rating');
      const preview = new URL(location.href).searchParams.get('preview_theme_id');
      if (preview) url.searchParams.set('preview_theme_id', preview);
      const key = url.href;
      if (!requests.has(key)) requests.set(key, (async () => {
        const response = await fetch(url, {headers:{Accept:'text/html'}});
        if (!response.ok) throw new Error('Product rating section unavailable');
        const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
        const source = parsed.querySelector('[data-dam-product-rating] .dam-v10-rating');
        // An empty, successfully rendered section represents a genuine zero-review product.
        if (!parsed.querySelector('[data-dam-product-rating]')) throw new Error('Invalid product rating section');
        return source ? {
          info: readBadge(source.dataset.damRatingSource || source.innerHTML),
          href: source.dataset.damRatingUrl,
          label: source.dataset.damRatingLabel,
        } : {info:null};
      })().catch(error => { requests.delete(key); throw error; }));
      try {
        const result = await requests.get(key);
        if (activeLoads.get(host) === token && host.isConnected) render(host, result.info, result.href, result.label);
      } catch {
        if (activeLoads.get(host) === token && host.isConnected) host.replaceChildren();
      }
    }
  };
  const boundFormats = new WeakSet();
  const boundComparisons = new WeakSet();
  const init = scope => {
    for (const button of scope.querySelectorAll('[data-dam-pick-format]')) {
      if (boundFormats.has(button)) continue;
      boundFormats.add(button);
      button.addEventListener('click', () => {
        const root = button.closest('.pbn-v2');
        const input = root?.querySelectorAll('[data-pbn-variant]')[Number(button.dataset.damPickFormat)];
        if (!input || input.disabled) return;
        input.checked = true; input.dispatchEvent(new Event('change',{bubbles:true}));
        input.closest('fieldset')?.scrollIntoView({block:'center',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
        input.focus({preventScroll:true});
      });
    }
    for (const stage of scope.querySelectorAll('[data-dam-compare]')) {
      if (boundComparisons.has(stage)) continue;
      boundComparisons.add(stage);
      const input = stage.querySelector('input[type=range]');
      const update = value => {
        input.value = String(Math.max(0,Math.min(100,Math.round(Number(value)))));
        stage.style.setProperty('--split',input.value+'%');
        input.setAttribute('aria-valuetext',stage.dataset.valueTemplate.replace('__PHOTO__',input.value).replace('__PAINTING__',String(100-Number(input.value))));
      };
      let pointer=null;
      const move = event => {const rect=stage.getBoundingClientRect();update((event.clientX-rect.left)/rect.width*100);};
      stage.addEventListener('pointerdown',event=>{if(event.button!==0)return;pointer=event.pointerId;input.focus({preventScroll:true});stage.setPointerCapture(pointer);move(event);});
      stage.addEventListener('pointermove',event=>{if(event.pointerId===pointer)move(event);});
      for(const name of ['pointerup','pointercancel','lostpointercapture'])stage.addEventListener(name,()=>pointer=null);
      input.addEventListener('input',()=>update(input.value));
      stage.parentElement.querySelector('[data-dam-compare-reset]')?.addEventListener('click',()=>update(50));
      update(50);
    }
  };
  if (!customElements.get('dam-v10-gallery')) customElements.define('dam-v10-gallery',class extends HTMLElement {
    connectedCallback() {
      if(this.ready)return;this.ready=true;
      const main=this.querySelector('[data-dam-gallery-main]'),choices=[...this.querySelectorAll('[data-dam-gallery-image]')],dialog=this.querySelector('dialog'),trigger=this.querySelector('[data-dam-zoom]');
      const show = button => {
        if(!button)return;
        main.src=button.dataset.damGalleryImage;main.alt=button.querySelector('img').alt;
        this.querySelector('[data-dam-gallery-count]').textContent=`${Number(button.dataset.damGalleryIndex)+1} / ${choices.length}`;
        choices.forEach(choice=>choice.setAttribute('aria-pressed',String(choice===button)));
        button.scrollIntoView({inline:'nearest',block:'nearest',behavior:'smooth'});
      };
      choices.forEach(button=>button.addEventListener('click',()=>show(button)));
      const step = delta => {
        const current = choices.findIndex(choice => choice.getAttribute('aria-pressed')==='true');
        const next = (Math.max(0, current) + delta + choices.length) % choices.length;
        show(choices[next]);
      };
      this.querySelector('[data-dam-gallery-prev]')?.addEventListener('click',()=>step(-1));
      this.querySelector('[data-dam-gallery-next]')?.addEventListener('click',()=>step(1));
      trigger.addEventListener('click',()=>{const image=this.querySelector('[data-dam-zoom-image]');image.src=main.src;image.alt=main.alt;dialog.showModal();});
      this.querySelector('[data-dam-zoom-close]').addEventListener('click',()=>dialog.close());
      dialog.addEventListener('click',event=>{if(event.target===dialog)dialog.close();});
      dialog.addEventListener('close',()=>trigger.focus({preventScroll:true}));
    }
  });
  const footerDesktop = matchMedia('(min-width: 601px)');
  const setFooterLayout = () => {
    for (const group of document.querySelectorAll('.dam-v10-footer-group')) group.open = footerDesktop.matches;
  };
  footerDesktop.addEventListener('change', setFooterLayout);
  setFooterLayout();
  const sticky=document.querySelector('.dam-v10-custom .dam-v10-sticky-purchase'),target=document.querySelector('.dam-v10-custom #landing-start');
  if(sticky&&target)new IntersectionObserver(entries=>{const e=entries[0];sticky.hidden=e.isIntersecting||e.boundingClientRect.bottom>0;}).observe(target);
  init(document);
  const fitCollectionSort = () => {
    const main = document.querySelector('#MainContent[data-template="collection"]');
    if (!main) return;
    for (const select of main.querySelectorAll('.sorting-filter__select')) {
      if (select.getBoundingClientRect().width === 0) continue;
      const probe = document.createElement('span');
      const cs = getComputedStyle(select);
      probe.textContent = select.selectedOptions[0]?.textContent?.trim() || '';
      probe.style.cssText = `position:absolute;left:-9999px;top:0;white-space:nowrap;font:${cs.font};letter-spacing:${cs.letterSpacing};visibility:hidden;pointer-events:none`;
      document.body.append(probe);
      select.style.width = `${Math.ceil(probe.getBoundingClientRect().width) + 2}px`;
      probe.remove();
    }
  };
  const bindCollectionSort = scope => {
    const root = scope && scope.querySelectorAll ? scope : document;
    for (const select of root.querySelectorAll('.sorting-filter__select')) {
      if (select.dataset.damSortFit) continue;
      select.dataset.damSortFit = 'true';
      select.addEventListener('change', fitCollectionSort);
    }
    fitCollectionSort();
  };
  bindCollectionSort(document);
  document.addEventListener('shopify:section:load', event => {
    init(event.target);
    setFooterLayout();
    bindCollectionSort(event.target);
  });

  const judgemeChrome = {
    de: {
      'Read original review': 'Originalbewertung lesen',
      'View review image': 'Bewertungsfoto ansehen',
      'Sort reviews by': 'Bewertungen sortieren',
      'Go to previous page': 'Zur vorherigen Seite',
      'Go to next page': 'Zur nächsten Seite',
      'Write a review': 'Bewertung schreiben',
      'Review form pages': 'Bewertungsformular',
      page: 'Zu Seite {n}',
      item: 'Zu Element {n}',
      viewProduct: '{name} ansehen'
    },
    fr: {
      'Read original review': 'Voir l’avis original',
      'View review image': 'Voir la photo de l’avis',
      'Sort reviews by': 'Trier les avis',
      'Go to previous page': 'Page précédente',
      'Go to next page': 'Page suivante',
      'Write a review': 'Écrire un avis',
      'Review form pages': 'Formulaire d’avis',
      page: 'Aller à la page {n}',
      item: 'Aller à l’élément {n}',
      viewProduct: 'Voir {name}'
    },
    es: {
      'Read original review': 'Ver la reseña original',
      'View review image': 'Ver la foto de la reseña',
      'Sort reviews by': 'Ordenar reseñas por',
      'Go to previous page': 'Página anterior',
      'Go to next page': 'Página siguiente',
      'Write a review': 'Escribir una reseña',
      'Review form pages': 'Formulario de reseñas',
      page: 'Ir a la página {n}',
      item: 'Ir al elemento {n}',
      viewProduct: 'Ver {name}'
    },
    it: {
      'Read original review': 'Leggi la recensione originale',
      'View review image': 'Vedi la foto della recensione',
      'Sort reviews by': 'Ordina le recensioni',
      'Go to previous page': 'Pagina precedente',
      'Go to next page': 'Pagina successiva',
      'Write a review': 'Scrivi una recensione',
      'Review form pages': 'Modulo recensioni',
      page: 'Vai alla pagina {n}',
      item: 'Vai all’elemento {n}',
      viewProduct: 'Vedi {name}'
    },
    nl: {
      'Read original review': 'Lees de originele beoordeling',
      'View review image': 'Bekijk de beoordelingsfoto',
      'Sort reviews by': 'Beoordelingen sorteren',
      'Go to previous page': 'Vorige pagina',
      'Go to next page': 'Volgende pagina',
      'Write a review': 'Schrijf een beoordeling',
      'Review form pages': 'Beoordelingsformulier',
      page: 'Ga naar pagina {n}',
      item: 'Ga naar item {n}',
      viewProduct: 'Bekijk {name}'
    }
  };
  const storefrontLocale = () => {
    const candidates = [
      String(window.Shopify?.locale || ''),
      String(document.documentElement.lang || ''),
      String(location.pathname.match(/^\/([a-z]{2})-[a-z]{2}\b/i)?.[1] || '')
    ];
    for (const value of candidates) {
      const locale = value.slice(0, 2).toLowerCase();
      if (judgemeChrome[locale]) return locale;
    }
    return 'en';
  };
  const localizeJudgemeText = value => {
    const map = judgemeChrome[storefrontLocale()];
    if (!map || !value) return value;
    const trimmed = value.trim();
    if (map[trimmed]) return value.replace(trimmed, map[trimmed]);
    const page = trimmed.match(/^Go to page (\d+)$/);
    if (page) return map.page.replace('{n}', page[1]);
    const item = trimmed.match(/^Go to item (\d+)$/);
    if (item) return map.item.replace('{n}', item[1]);
    const product = trimmed.match(/^View (.+) product page$/);
    if (product) return map.viewProduct.replace('{name}', product[1]);
    return value;
  };
  const localizeJudgemeNode = node => {
    if (!node || node.nodeType !== 1) return;
    for (const attr of ['aria-label', 'title']) {
      const current = node.getAttribute(attr);
      const next = localizeJudgemeText(current);
      if (next && next !== current) node.setAttribute(attr, next);
    }
    for (const child of node.childNodes) {
      if (child.nodeType === 3) {
        const next = localizeJudgemeText(child.textContent);
        if (next !== child.textContent) child.textContent = next;
      }
    }
  };
  const localizeJudgemeTree = root => {
    if (!root) return;
    if (root.nodeType === 3) {
      localizeJudgemeNode(root.parentElement);
      return;
    }
    if (root.nodeType !== 1) return;
    localizeJudgemeNode(root);
    for (const node of root.querySelectorAll('[aria-label], [title], a, button, span, p, h2, h3, h4, legend, label')) {
      localizeJudgemeNode(node);
    }
  };
  const bindJudgemeI18n = () => {
    if (storefrontLocale() === 'en') return;
    const rerun = () => localizeJudgemeTree(document.body);
    rerun();
    const observer = new MutationObserver(records => {
      for (const record of records) {
        for (const node of record.addedNodes) localizeJudgemeTree(node);
        if (record.type === 'attributes' && record.target instanceof Element) localizeJudgemeNode(record.target);
        if (record.type === 'characterData') localizeJudgemeNode(record.target.parentElement);
      }
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['aria-label', 'title']
    });
    [400, 1200, 3000, 6000].forEach(delay => setTimeout(rerun, delay));
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bindJudgemeI18n, { once: true });
  else bindJudgemeI18n();
})();
